import React from 'react';

const socialLinks = [
  {
    name: 'Facebook',
    text: 'Follow us on Facebook',
    url: 'https://www.facebook.com',
    color: '#3b5998', // Facebook Blue
    icon: (
      <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg>
    )
  },
  {
    name: 'Instagram',
    text: 'Follow us on Instagram',
    url: 'https://instagram.com',
    color: '#da7c43', // Solid Orange/Brown
    icon: (
      <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.051.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/>
      </svg>
    )
  },
  {
    name: 'WhatsApp',
    text: 'Chat on WhatsApp',
    url: 'https://wa.me/919876543210',
    color: '#25D366', // Original WhatsApp Green
    icon: (
      <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946C.06 5.348 5.397.01 12.008.01c3.202.001 6.212 1.246 8.477 3.514 2.266 2.268 3.507 5.28 3.505 8.484-.004 6.657-5.34 11.997-11.953 11.997-2.005-.001-3.973-.502-5.724-1.455L0 24zM15.85 12.7c-.26-.13-1.56-.77-1.8-.86-.24-.09-.42-.13-.59.13-.17.26-.68.86-.83 1.03-.15.17-.3.2-.56.07-.26-.13-1.1-.4-2.1-1.3-.77-.7-1.3-1.55-1.45-1.8-.15-.26-.02-.4.11-.53.12-.12.26-.3.4-.45.13-.15.17-.26.26-.43.09-.17.04-.32-.02-.45-.06-.13-.59-1.42-.8-1.94-.2-.5-.43-.43-.59-.44-.15-.01-.33-.01-.5-.01-.17 0-.45.06-.68.32-.24.26-.9.88-.9 2.14 0 1.27.92 2.5 1.05 2.67.13.17 1.8 2.75 4.37 3.86.6.26 1.09.42 1.46.54.6.19 1.15.16 1.59.1.49-.07 1.56-.64 1.78-1.25.22-.61.22-1.14.16-1.25-.07-.12-.24-.18-.51-.31z"
        />
      </svg>
    )
  },
  {
    name: 'LinkedIn',
    text: 'Connect on LinkedIn',
    url: 'https://linkedin.com',
    color: '#3b7bc1', // Medium Blue
    icon: (
      <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24">
        <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
      </svg>
    )
  }
];

export default function SocialSidebar() {
  return (
    <div className="fixed right-0 top-1/2 -translate-y-1/2 z-50 flex flex-col items-end space-y-0">
      {socialLinks.map((link, index) => (
        <a
          key={link.name}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          className={`group flex flex-row-reverse items-center justify-start h-10 shadow-lg transition-all duration-300 ease-in-out hover:w-52 w-10 overflow-hidden text-white font-poppins
            ${index === 0 ? 'rounded-tl-lg' : ''}
            ${index === socialLinks.length - 1 ? 'rounded-bl-lg' : ''}
            hover:rounded-l-lg
          `}
          style={{
            background: link.color
          }}
        >
          {/* Social Icon Container */}
          <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-black/10 text-white">
            {link.icon}
          </div>

          {/* Expanded text label */}
          <span className="flex-grow text-left pl-3 font-semibold tracking-wide text-xs whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200">
            {link.text}
          </span>
        </a>
      ))}
    </div>
  );
}
